
// import React, { useState, useEffect } from "react";
// import moment from "moment";
// import staticflightsdata from "../Data/ReturnData.json";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import Header from "../../Common/Layout/Header";
// import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import ModifyFlightSearch from "./ModifyFlightSearch";
// import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
// import { ShareEmail } from "../../Common/Helpers/ShareEmail";
// import FlightLoader from "../../Common/Layout/FlightLoader";
// import BookingConfirmationModal from "./BookingConfirmationModal";
// import {
//   RiPriceTag3Line,
//   RiExternalLinkLine,
//   RiInformationLine,
// } from "react-icons/ri";

// const Flights = () => {
//   const { user, loading, currencies } = useAuth();
//   const params = useParams();
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const [pageLoading, setPageLoading] = useState(false);
//   const [currency, setCurrency] = useState(user?.currency);
//   const [flightData, setFlightData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState({});
//   const [activeTab, setActiveTab] = useState(0);
//   const [expandedFlights, setExpandedFlights] = useState({}); // Track which flights have fares expanded
//   const [selectedFares, setSelectedFares] = useState({}); // Track selected fare per flight
//   const [showBookingModal, setShowBookingModal] = useState(false);

//   // New states for Series Fares
//   const [seriesFaresCount, setSeriesFaresCount] = useState(0);
//   const [loadingSeriesFares, setLoadingSeriesFares] = useState(false);

//   const handleCurrencyChange = (newCurrency) => {
//     setCurrency(newCurrency);
//   };
//   /* List Start */
//   const [filters, setFilters] = useState({
//     airlines: [],
//     priceRange: [0, 9999999],
//     departureTime: "",
//     stops: [],
//   });
//   const getAirlines = () => {
//     const set = new Set();
//     flightData.forEach((tab) =>
//       tab.dcFlightLegs.forEach((flight) =>
//         set.add(flight.dcDisplayLegs[0]?.airlineData?.airline),
//       ),
//     );
//     return Array.from(set);
//   };
//   const handleFilterChange = (type, value) => {
//     setFilters((prev) => {
//       if (type === "airlines" || type === "stops") {
//         const updated = prev[type].includes(value)
//           ? prev[type].filter((v) => v !== value)
//           : [...prev[type], value];
//         return { ...prev, [type]: updated };
//       } else if (type === "priceRange") {
//         return { ...prev, priceRange: value };
//       } else {
//         return { ...prev, [type]: value };
//       }
//     });
//   };
//   const applyFilters = (flights) => {
//     return flights.filter((flight) => {
//       const displayLeg = flight.dcDisplayLegs[0];
//       const airline = displayLeg?.airlineData?.airline;
//       const stops = displayLeg?.stops;
//       const price = flight.totalPrice || 0;
//       const departureHour = new Date(
//         displayLeg?.startSegment.departureDateTime,
//       ).getHours();

//       return (
//         (filters.airlines.length === 0 || filters.airlines.includes(airline)) &&
//         (filters.stops.length === 0 || filters.stops.includes(stops)) &&
//         price >= filters.priceRange[0] &&
//         price <= filters.priceRange[1] &&
//         (!filters.departureTime ||
//           (filters.departureTime === "morning" &&
//             departureHour >= 5 &&
//             departureHour < 12) ||
//           (filters.departureTime === "afternoon" &&
//             departureHour >= 12 &&
//             departureHour < 17) ||
//           (filters.departureTime === "evening" &&
//             departureHour >= 17 &&
//             departureHour < 21) ||
//           (filters.departureTime === "night" &&
//             (departureHour >= 21 || departureHour < 5)))
//       );
//     });
//   };
//   const handleClearFilters = () => {
//     setFilters({
//       airlines: [],
//       priceRange: [0, 9999999],
//       departureTime: "",
//       stops: [],
//     });
//   };
//   function getTimeFromMins(mins) {
//     var h = (mins / 60) | 0,
//       m = (mins % 60) | 0;
//     var durationformat = h + "h " + m + "m";
//     return durationformat;
//   }
//   const handleToggleFares = (supplierLegId) => {
//     setExpandedFlights((prev) => ({
//       ...prev,
//       [supplierLegId]: !prev[supplierLegId],
//     }));
//   };
//   const handleSelectFare = (
//     journeyType,
//     flightLeg,
//     selectedSupplierPriceId,
//   ) => {
//     const selectedFare = flightLeg.dcPriceDetails.find(
//       (fare) => fare.supplierPriceId === selectedSupplierPriceId,
//     );

//     if (selectedFare) {
//       setSelectedFares((prev) => ({
//         ...prev,
//         [journeyType]: {
//           flightLeg,
//           fare: selectedFare,
//         },
//       }));
//     }
//   };

//   const formatFlightDetails = (flightLeg) => {
//     const displayLeg = flightLeg.dcDisplayLegs[0];
//     const segments = flightLeg.dcSegments;
//     const viaCities =
//       segments.length > 1
//         ? segments
//             .slice(0, -1)
//             .map((seg) => `(${seg.tFArrivalData.airportCode})`)
//             .join(", ")
//         : "";

//     return `
// ONWARD: 🛫 ${displayLeg.airlineData.airline} (${
//       displayLeg.airlineData.flightNumber
//     }) :
// ${displayLeg.startSegment.airportCode} (${displayLeg.startSegment.city}) - ${
//       displayLeg.endSegment.airportCode
//     } (${displayLeg.endSegment.city})${viaCities ? `( via ${viaCities})` : ""}
// Departure: ${moment(displayLeg.startSegment.departureDateTime).format(
//       "ddd, DD MMM YY HH:mm",
//     )}
// Arrival: ${moment(displayLeg.endSegment.arrivalDateTime).format(
//       "ddd, DD MMM YY HH:mm",
//     )}
// Duration: ${getTimeFromMins(displayLeg.totalDuration)} / ${
//       displayLeg.stops === 0
//         ? "Non-stop"
//         : `${displayLeg.stops} stop${displayLeg.stops > 1 ? "s" : ""}`
//     }

// TOTAL PRICE: ${currency} ${flightLeg.totalPrice.toLocaleString("en-IN")}`;
//   };

//   const shareViaWhatsApp = (flightLeg) => {
//     const passengerDetails = [
//       params.adults > 0 &&
//         `${params.adults} Adult${params.adults > 1 ? "s" : ""}`,
//       params.kids > 0 && `${params.kids} Kid${params.kids > 1 ? "s" : ""}`,
//       params.infants > 0 &&
//         `${params.infants} Infant${params.infants > 1 ? "s" : ""}`,
//     ]
//       .filter(Boolean)
//       .join(" | ");

//     const message = `Hello Traveler, please find your flight details:

// Journey: ${flightData[activeTab]?.locationFrom} - ${
//       flightData[activeTab]?.locationTo
//     }
// Passengers: ${passengerDetails}
// Cabin Class: ${flightLeg.dcPriceDetails[0]?.dcAdults?.cabinClass}

// FLIGHT DETAILS:
// --------------------------------------------------------------------------------
// ${formatFlightDetails(flightLeg)}
// --------------------------------------------------------------------------------
// Thank you for choosing ${user?.brandName}

// In case of any support:
// ☎️ Contact : ${user?.phoneNumber}
// ✉ Email     : ${user?.email}`;

//     window.open(
//       `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`,
//       "_blank",
//     );
//   };
//   const shareViaEmail = (flightLeg) => {
//     const subject = `Your Flight Details: ${flightData[activeTab]?.locationFrom} to ${flightData[activeTab]?.locationTo}`;
//     const body = `Hello,

// Please find details with regards to your flight(s) query for:
// ${flightData[activeTab]?.locationFrom} - ${flightData[activeTab]?.locationTo}
// ${params.adults} Adult${params.adults > 1 ? "s" : ""}
// ${flightLeg.dcPriceDetails[0]?.fareIdentifier}

// Below mentioned prices are the total price(s) inclusive of taxes:
// --------------------------------------------------------------------------------
// ${formatFlightDetails(flightLeg)}
// --------------------------------------------------------------------------------
// Thank you for choosing ${user?.brandName}

// In case of any support:
// Contact: ${user?.phoneNumber}
// Email: ${user?.email}

// Best regards,
// ${user?.name}`;
//     ShareEmail({
//       subject,
//       body,
//       // to: "customer@example.com", // Optional
//       preferGmail: false, // Set to true if you want to *always* open Gmail
//     });
//     //window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//   };

//   const BindPageData = (searchQuery) => {
//     setPageLoading(true);
//     GetFlights(searchQuery);
//     // Fetch series fares count
//     fetchSeriesFaresCount(searchQuery);
//   };

//   // Function to fetch series fares count
//   const fetchSeriesFaresCount = async (searchQuery) => {
//     try {
//       setLoadingSeriesFares(true);

//       // Get search parameters
//       const firstTrip = searchQuery.flightTravelerPoints?.[0];
//       if (!firstTrip) {
//         setSeriesFaresCount(0);
//         return;
//       }

//       const from = firstTrip.from || "";
//       const to = firstTrip.to || "";
//       const date = firstTrip.departureDate || "";
//       const pax =
//         (searchQuery.adults || 0) +
//         (searchQuery.kids || 0) +
//         (searchQuery.infants || 0);

//       if (!from || !to || !date) {
//         setSeriesFaresCount(0);
//         return;
//       }

//       // Call series fares count API
//       const response = await apiService.getAll(
//         `${config.SERIESFARESEARCH}?from=${from}&to=${to}&date=${date}&pax=${pax}`,
//       );

//       if (response && response.count !== undefined) {
//         setSeriesFaresCount(response.count);
//       } else {
//         setSeriesFaresCount(0);
//       }
//     } catch (error) {
//       console.error("Error fetching series fares count:", error);
//       setSeriesFaresCount(0);
//     } finally {
//       setLoadingSeriesFares(false);
//     }
//   };

//   // // Function to handle viewing series fares
//   // const handleViewSeriesFares = () => {
//   //   if (!state?.searchQuery) return;

//   //   const searchQuery = state.searchQuery;
//   //   const firstTrip = searchQuery.flightTravelerPoints?.[0];

//   //   if (!firstTrip) return;

//   //   const seriesSearchData = {
//   //     from: firstTrip.from || '',
//   //     to: firstTrip.to || '',
//   //     date: firstTrip.departureDate || '',
//   //     pax: (searchQuery.adults || 0) + (searchQuery.kids || 0) + (searchQuery.infants || 0),
//   //     cabinClass: searchQuery.cabinClass || 'ECONOMY',
//   //     journeyType: searchQuery.journeyType || 'ONEWAY',
//   //     isDomestic: searchQuery.isDomestic || 'DOMESTIC'
//   //   };

//   //   // Navigate to series fares agent search
//   //   navigate("/flights/series-fares", {
//   //     state: {
//   //       searchQuery: seriesSearchData,
//   //       passengerCount: seriesSearchData.pax
//   //     }
//   //   });
//   // };

//   // In Flights.js - Update the handleViewSeriesFares function
//   const handleViewSeriesFares = () => {
//     if (!state?.searchQuery) return;

//     const searchQuery = state.searchQuery;
//     const firstTrip = searchQuery.flightTravelerPoints?.[0];

//     if (!firstTrip) return;

//     // Prepare the search data
//     const seriesSearchData = {
//       from: firstTrip.from || "",
//       to: firstTrip.to || "",
//       date: firstTrip.departureDate || "",
//       pax:
//         (searchQuery.adults || 0) +
//         (searchQuery.kids || 0) +
//         (searchQuery.infants || 0),
//       cabinClass: searchQuery.cabinClass || "ECONOMY",
//       journeyType: searchQuery.journeyType || "ONEWAY",
//       isDomestic: searchQuery.isDomestic || "DOMESTIC",
//     };

//     // Navigate to series fares page
//     navigate("/seriesfare/agent-search", {
//       state: {
//         searchQuery: seriesSearchData,
//         passengerCount: seriesSearchData.pax,
//         // Add these to help with auto-search
//         shouldAutoSearch: true, // Flag to indicate auto-search should happen
//         fromAirportCode: firstTrip.from,
//         toAirportCode: firstTrip.to,
//         travelDate: firstTrip.departureDate,
//       },
//     });
//   };

//   const GetFlights = async (searchQuery) => {
//     var result = await apiService.post(config.SEARCHFLIGHTS, searchQuery);
//     console.log(result);
//     if (result.length > 0) {
//       const defaultSelected = {};
//       const sortedData = result.map((destination) => {
//         const sortedLegs = [...destination.dcFlightLegs].sort(
//           (a, b) => a.totalPrice - b.totalPrice,
//         );

//         const cheapestLeg = sortedLegs[0];
//         let matchingFare = null;

//         if (cheapestLeg?.dcPriceDetails?.length > 0) {
//           matchingFare = [...cheapestLeg.dcPriceDetails].sort(
//             (a, b) => a.totalPrice - b.totalPrice,
//           )[0];
//         }

//         if (cheapestLeg && matchingFare) {
//           defaultSelected[destination.journeyType] = {
//             flightLeg: cheapestLeg,
//             fare: matchingFare,
//           };
//         }

//         return {
//           ...destination,
//           dcFlightLegs: sortedLegs,
//         };
//       });

//       setFlightData(sortedData);
//       setSelectedFares(defaultSelected);
//     } else {
//       alert("No flights found");
//     }
//     setPageLoading(false);
//   };
//   // const handleSubmit = (e) => {
//   //   e.preventDefault();
//   //   console.log(selectedFares);
//   //   const payload = Object.values(selectedFares).map(({ flightLeg, fare }) => ({
//   //     flightLeg: flightLeg,
//   //     fare: fare,
//   //   }));
//   //   navigate(
//   //     "/flightdetails/" +
//   //     params.adults +
//   //     "/" +
//   //     params.kids +
//   //     "/" +
//   //     params.infants +
//   //     "/" +
//   //     params.isDomestic,
//   //     { state: { searchQuery, payload } }
//   //   );
//   // };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Instead of navigating, just open the modal
//     setShowBookingModal(true);
//   };

//   const handleContinueBooking = () => {
//     setShowBookingModal(false); // Close the modal first
//     const payload = Object.values(selectedFares).map(({ flightLeg, fare }) => ({
//       flightLeg: flightLeg,
//       fare: fare,
//     }));
//     navigate(
//       "/flightdetails/" +
//         params.adults +
//         "/" +
//         params.kids +
//         "/" +
//         params.infants +
//         "/" +
//         params.isDomestic,
//       { state: { searchQuery, payload } },
//     );
//   };
//   // KEY CHANGE 5: Create a function to handle "Book with Supplier"
//   const handleBookWithSupplier = () => {
//     setShowBookingModal(false);
//     // You will add the actual supplier URL here later
//     // For now, it opens a blank new tab
//     window.open("", "_blank");
//     // You could also show a toast message
//     // toast.info("Redirecting to supplier portal...");
//   };

//   /*List End */
//   /* useEffect(() => {
//     if (!staticflightsdata || staticflightsdata.length === 0) return;

//     const defaultSelected = {};
//     const sortedData = staticflightsdata.map((destination) => {
//       const sortedLegs = [...destination.dcFlightLegs].sort(
//         (a, b) => a.totalPrice - b.totalPrice
//       );

//       const cheapestLeg = sortedLegs[0];
//       let matchingFare = null;

//       if (cheapestLeg?.dcPriceDetails?.length > 0) {
//         matchingFare = [...cheapestLeg.dcPriceDetails].sort(
//           (a, b) => a.totalPrice - b.totalPrice
//         )[0];
//       }

//       if (cheapestLeg && matchingFare) {
//         defaultSelected[destination.journeyType] = {
//           flightLeg: cheapestLeg,
//           fare: matchingFare,
//         };
//       }

//       return {
//         ...destination,
//         dcFlightLegs: sortedLegs,
//       };
//     });

//     setFlightData(sortedData);
//     setSelectedFares(defaultSelected);
//  }, [staticflightsdata]); */

//   const handleSearch = (query) => {
//     setSearchQuery(query);
//     setPageLoading(true);
//     BindPageData(query);
//   };
//   useEffect(() => {
//     if (state === null) {
//       navigate("/flight/search");
//     } else if (params === null) {
//       navigate("/flight/search");
//     } else if (state.searchQuery === null) {
//       navigate("/flight/search");
//     } else {
//       setSearchQuery(state.searchQuery);
//       setPageLoading(true);
//       BindPageData(state.searchQuery);
//     }
//     if (loading) return <p>Loading...</p>;
//     if (!user) {
//       navigate("/");
//     }
//   }, []);
//   return (
//     <div id="layout-wrapper">
//       <Header />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             {/* start page title */}
//             <div className="card">
//               <ModifyFlightSearch onSearch={handleSearch}></ModifyFlightSearch>
//             </div>
//             {/* end page title */}
//             {pageLoading === true ? (
//               <div className="row">
//                 <div className="col-12">
//                   <div className="text-center">
//                     <div className="branded-loader-wrapper">
//                       <FlightLoader />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div className="row">
//                 <div className="col-3">
//                   <div className="card">
//                     <div className="card-header">
//                       <div className="d-flex mb-0">
//                         <div className="flex-grow-1">
//                           <h5 className="fs-16">Filters</h5>
//                         </div>
//                         <div className="flex-shrink-0">
//                           <Link
//                             onClick={handleClearFilters}
//                             className="text-decoration-underline"
//                           >
//                             Clear All
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="card-body">
//                       {/* Series Fares Filter */}
//                       <div
//                         className="series-fares-filter"
//                         style={{
//                           marginTop: "15px",
//                           padding: "12px",
//                           backgroundColor: "#f8f9fa",
//                           borderRadius: "8px",
//                           borderLeft: "4px solid #0dcaf0",
//                         }}
//                       >
//                         <div className="d-flex justify-content-between align-items-center mb-2">
//                           <div className="d-flex align-items-center">
//                             <RiPriceTag3Line className="me-2 text-info" />
//                             <p className="text-muted text-uppercase fs-12 fw-medium mb-0">
//                               Series Fares
//                             </p>
//                           </div>
//                           <div className="text-end">
//                             {loadingSeriesFares ? (
//                               <span
//                                 className="spinner-border spinner-border-sm text-info"
//                                 role="status"
//                               ></span>
//                             ) : (
//                               <span className="badge bg-info rounded-pill">
//                                 {seriesFaresCount}
//                               </span>
//                             )}
//                           </div>
//                         </div>

//                         <div
//                           className="text-muted small mb-2"
//                           style={{ fontSize: "11px" }}
//                         >
//                           Guaranteed seat packages at fixed prices
//                         </div>

//                         <button
//                           type="button"
//                           className="btn btn-info btn-sm w-100"
//                           onClick={handleViewSeriesFares}
//                           disabled={
//                             seriesFaresCount === 0 || loadingSeriesFares
//                           }
//                           style={{
//                             borderColor: "#0dcaf0",
//                             color: "#010d0fff",
//                             fontSize: "12px",
//                             padding: "5px 10px",
//                             borderRadius: "5px",
//                           }}
//                         >
//                           {loadingSeriesFares ? (
//                             <>
//                               <span
//                                 className="spinner-border spinner-border-sm me-1"
//                                 role="status"
//                               ></span>
//                               Checking...
//                             </>
//                           ) : (
//                             <>
//                               <RiExternalLinkLine className="me-1" />
//                               {seriesFaresCount > 0
//                                 ? `View ${seriesFaresCount} Series Fare${seriesFaresCount > 1 ? "s" : ""}`
//                                 : "No Series Fares"}
//                             </>
//                           )}
//                         </button>

//                         {seriesFaresCount > 0 && (
//                           <div
//                             className="mt-2 text-info small"
//                             style={{ fontSize: "11px" }}
//                           >
//                             <RiInformationLine className="me-1" />
//                             Click to view fixed-price guaranteed seats
//                           </div>
//                         )}
//                       </div>

//                       <div style={{ marginTop: "10px" }}>
//                         <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
//                           Stops
//                         </p>
//                         {[0, 1, 2].map((stop) => (
//                           <div key={stop}>
//                             <label
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "8px",
//                               }}
//                             >
//                               <input
//                                 type="checkbox"
//                                 checked={filters.stops.includes(stop)}
//                                 onChange={() =>
//                                   handleFilterChange("stops", stop)
//                                 }
//                               />
//                               {stop} Stop{stop !== 1 ? "s" : ""}
//                             </label>
//                           </div>
//                         ))}
//                       </div>
//                       <div style={{ marginTop: "10px" }}>
//                         <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
//                           Departure Time
//                         </p>
//                         {["morning", "afternoon", "evening", "night"].map(
//                           (slot) => (
//                             <div key={slot}>
//                               <label
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "8px",
//                                 }}
//                               >
//                                 <input
//                                   type="radio"
//                                   name="departureTime"
//                                   checked={filters.departureTime === slot}
//                                   onChange={() =>
//                                     handleFilterChange("departureTime", slot)
//                                   }
//                                 />
//                                 {slot.charAt(0).toUpperCase() + slot.slice(1)}
//                               </label>
//                             </div>
//                           ),
//                         )}
//                       </div>
//                       <div style={{ marginTop: "10px" }}>
//                         <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
//                           Price Range
//                         </p>
//                         <input
//                           type="range"
//                           min={0}
//                           max={9999999}
//                           value={filters.priceRange[1]}
//                           onChange={(e) =>
//                             handleFilterChange("priceRange", [
//                               0,
//                               parseInt(e.target.value),
//                             ])
//                           }
//                         />
//                         <div>Up to INR {filters.priceRange[1]}</div>
//                       </div>
//                       <div style={{ marginTop: "10px" }}>
//                         <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
//                           Airlines
//                         </p>
//                         {getAirlines().map((airline, idx) => (
//                           <div key={idx}>
//                             <label
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "8px",
//                               }}
//                             >
//                               <input
//                                 type="checkbox"
//                                 checked={filters.airlines.includes(airline)}
//                                 onChange={() =>
//                                   handleFilterChange("airlines", airline)
//                                 }
//                               />
//                               {airline}
//                             </label>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   {/* end card */}
//                 </div>
//                 <div className="col-9">
//                   <div
//                     className="card mb-3 border-0 shadow-sm"
//                     style={{ borderRadius: "15px" }}
//                   >
//                     <div className="card-header border-0 bg-white py-3">
//                       <ul
//                         className="nav nav-pills arrow-navtabs nav-success card-header-tabs border-bottom-0"
//                         role="tablist"
//                       >
//                         {flightData.length > 0 &&
//                           flightData.map((item, index) => (
//                             <li className="nav-item" key={index}>
//                               <a
//                                 className={`nav-link fw-bold px-4 py-2 rounded-pill ${activeTab === index ? "active shadow-sm" : "text-muted"}`}
//                                 onClick={() => setActiveTab(index)}
//                                 style={{ cursor: "pointer" }}
//                               >
//                                 {item.locationFrom} ➝ {item.locationTo}
//                                 <span className="ms-2 badge rounded-pill bg-light text-dark border fw-normal">
//                                   {item.dcFlightLegs.length} flights
//                                 </span>
//                               </a>
//                             </li>
//                           ))}
//                       </ul>
//                     </div>
//                   </div>

//                   {/* MAIN FLIGHT LIST CONTAINER */}
//                   <div className="d-flex flex-column gap-4">
//                     {applyFilters(
//                       (flightData.length > 0 &&
//                         flightData[activeTab]?.dcFlightLegs) ||
//                         [],
//                     )?.map((flightLeg, idx) => {
//                       const mainLeg = flightLeg.dcDisplayLegs[0];
//                       const isSelected =
//                         selectedFares[flightData[activeTab]?.journeyType]
//                           ?.flightLeg?.supplierLegId ===
//                         flightLeg.supplierLegId;
//                       const minPrice = Math.min(
//                         ...flightLeg.dcPriceDetails.map(
//                           (fare) => fare.totalPrice || Infinity,
//                         ),
//                       );
//                       const fareIdentifier =
//                         flightLeg.dcPriceDetails[0]?.fareIdentifier;

//                       return (
//                         <div key={idx} className="flight-item-wrapper">
//                           {/* THE MAIN FLIGHT CARD */}
//                           <div
//                             className="card border-0 shadow-sm overflow-hidden"
//                             style={{
//                               borderRadius: "10px",
//                               transition: "all 0.3s ease",
//                               borderLeft: isSelected
//                                 ? "6px solid #2563EB"
//                                 : "6px solid #E2E8F0",
//                               background: "#fff",
//                             }}
//                           >
//                             <div className="card-body p-0">
//                               <div className="row g-0 align-items-center">
//                                 {/* 1. Airline Info */}
//                                 <div className="col-lg-2 text-center border-end bg-light-subtle">
//                                   <div className="bg-white rounded-3 p-2 d-inline-block shadow-sm mb-2">
//                                     <img
//                                       src={
//                                         "/assets/images/airlinelogos/" +
//                                         mainLeg?.airlineData?.airlineCode +
//                                         ".png"
//                                       }
//                                       alt={mainLeg?.airlineData?.airlineCode}
//                                       style={{
//                                         width: "50px",
//                                         height: "50px",
//                                         objectFit: "contain",
//                                       }}
//                                     />
//                                   </div>
//                                   <h6 className="fw-bold text-dark mb-0">
//                                     {mainLeg?.airlineData?.flightNumber}
//                                   </h6>
//                                   <p className="text-muted small mb-0 fw-medium">
//                                     {mainLeg?.airlineData?.airline}
//                                   </p>
//                                 </div>
//                                 {/* 2. Timeline Visual */}
//                                 <div className="col-lg-7 p-4">
//                                   <div className="row align-items-center text-center">
//                                     <div className="col-4">
//                                       <h3 className="fw-bolder text-dark mb-1">
//                                         {moment(
//                                           mainLeg?.startSegment
//                                             ?.departureDateTime,
//                                         ).format("HH:mm")}
//                                       </h3>
//                                       <div className="badge bg-soft-primary text-primary px-3 rounded-pill mb-1 fs-6">
//                                         {mainLeg?.startSegment?.airportCode}
//                                       </div>
//                                       <p className="text-muted small mb-0">
//                                         {moment(
//                                           mainLeg?.startSegment
//                                             ?.departureDateTime,
//                                         ).format("DD MMM YY")}
//                                       </p>
//                                     </div>
//                                     <div className="col-4 px-2 text-center">
//                                       <p className="text-muted small mb-1 fw-bold">
//                                         {getTimeFromMins(mainLeg.totalDuration)}
//                                       </p>
//                                       <div className="d-flex align-items-center justify-content-center gap-1 opacity-75">
//                                         <i className="ri-flight-takeoff-line text-primary fs-5"></i>
//                                         <div
//                                           className="flex-grow-1 border-bottom border-primary border-dashed"
//                                           style={{ height: "1px" }}
//                                         ></div>
//                                         <i className="ri-flight-land-line text-primary fs-5"></i>
//                                       </div>
//                                       <p
//                                         className={`small mt-1 mb-0 fw-bold ${mainLeg.stops === 0 ? "text-success" : "text-warning"}`}
//                                       >
//                                         {mainLeg.stops === 0
//                                           ? "Non-Stop"
//                                           : `${mainLeg.stops} Stop`}
//                                       </p>
//                                     </div>
//                                     <div className="col-4">
//                                       <h3 className="fw-bolder text-dark mb-1">
//                                         {moment(
//                                           mainLeg?.endSegment?.arrivalDateTime,
//                                         ).format("HH:mm")}
//                                       </h3>
//                                       <div className="badge bg-soft-primary text-primary px-3 rounded-pill mb-1 fs-6">
//                                         {mainLeg?.endSegment?.airportCode}
//                                       </div>
//                                       <p className="text-muted small mb-0">
//                                         {moment(
//                                           mainLeg?.endSegment?.arrivalDateTime,
//                                         ).format("DD MMM YY")}
//                                       </p>
//                                     </div>
//                                   </div>
//                                 </div>

//                                 {/* 3. Pricing & Select */}
//                                 <div className="col-lg-3 p-4 bg-light-subtle border-start text-center d-flex flex-column justify-content-center gap-2">
//                                   <div className="mb-2">
//                                     <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
//                                       {/* Fare Identifier */}
//                                       <span className="badge bg-success text-white px-2 py-1 shadow-sm">
//                                         {fareIdentifier}
//                                       </span>

//                                       {/* WhatsApp */}
//                                       <Link
//                                         onClick={() =>
//                                           shareViaWhatsApp(flightLeg)
//                                         }
//                                         className="text-success"
//                                         title="Share via WhatsApp"
//                                       >
//                                         <i className="ri-whatsapp-fill fs-6"></i>
//                                       </Link>

//                                       {/* Email */}
//                                       <Link
//                                         onClick={() => shareViaEmail(flightLeg)}
//                                         className="text-primary"
//                                         title="Share via Email"
//                                       >
//                                         <i className="ri-mail-fill fs-6"></i>
//                                       </Link>

//                                       {/* Details */}
//                                       <Link
//                                         className="text-decoration-none text-dark"
//                                         title="View Details"
//                                         data-bs-toggle="modal"
//                                         data-bs-target={
//                                           "#flight" + flightLeg.supplierLegId
//                                         }
//                                       >
//                                         <i className="ri-information-fill fs-6"></i>
//                                       </Link>
//                                     </div>
//                                     <div className="d-flex align-items-baseline justify-content-center">
//                                       <span className="text small fw-bold me-1">
//                                         {currency}
//                                       </span>
//                                       <h5 className="fw-bolder text-dark mb-0">
//                                         {minPrice.toLocaleString("en-IN")}
//                                       </h5>
//                                     </div>
//                                     <div className="small text fw-bold mt-1">
//                                       Via {flightLeg.supplierName}
//                                     </div>
//                                   </div>
//                                   <div className="d-flex gap-2 align-items-center">
//                                     {isSelected ? (
//                                       <button
//                                         className="btn btn-success fw-bold rounded-pill shadow-sm py-2"
//                                         disabled
//                                       >
//                                         SELECTED
//                                       </button>
//                                     ) : (
//                                       <button
//                                         className="btn btn-primary fw-bold rounded-pill shadow-sm py-2"
//                                         onClick={() =>
//                                           handleSelectFare(
//                                             flightData[activeTab]?.journeyType,
//                                             flightLeg,
//                                             flightLeg.dcPriceDetails[0]
//                                               .supplierPriceId,
//                                           )
//                                         }
//                                       >
//                                         SELECT
//                                       </button>
//                                     )}

//                                     <button
//                                       className={`btn btn-sm fw-bold rounded-pill py-2 ${
//                                         expandedFlights[flightLeg.supplierLegId]
//                                           ? "btn-dark"
//                                           : "btn-outline-warning text-dark"
//                                       }`}
//                                       onClick={() =>
//                                         handleToggleFares(
//                                           flightLeg.supplierLegId,
//                                         )
//                                       }
//                                     >
//                                       {expandedFlights[flightLeg.supplierLegId]
//                                         ? "HIDE"
//                                         : "COMPARE"}
//                                     </button>
//                                   </div>
//                                   {/* <div className="d-flex align-items-center justify-content-center gap-3 mt-2 border-top pt-2">
//                                     <Link
//                                       onClick={() =>
//                                         shareViaWhatsApp(flightLeg)
//                                       }
//                                       className="text-success"
//                                     >
//                                       <i className="ri-whatsapp-fill fs-5"></i>
//                                     </Link>
//                                     <Link
//                                       onClick={() => shareViaEmail(flightLeg)}
//                                       className="text-primary"
//                                     >
//                                       <i className="ri-mail-fill fs-5"></i>
//                                     </Link>
//                                     <Link
//                                       className="text small fw-bolder text-decoration-none"
//                                       data-bs-toggle="modal"
//                                       data-bs-target={
//                                         "#flight" + flightLeg.supplierLegId
//                                       }
//                                     >
//                                       DETAILS
//                                     </Link>
//                                   </div> */}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           {/* DESIGN 4 UPDATED: HORIZONTAL FILMSTRIP WITH FULL DATA & FIXES */}
//                           {expandedFlights[flightLeg.supplierLegId] && (
//                             <div
//                               className="mt-2 mx-3 border-top bg-light shadow-inner"
//                               style={{
//                                 marginTop: "-15px",
//                                 paddingTop: "10px",
//                                 borderRadius: "0 0 20px 20px",
//                               }}
//                             >
//                               <div className="p-3">
//                                 <div className="d-flex align-items-center justify-content-between mb-3 px-1">
//                                   <div className="small fw-bold text-dark text-uppercase ls-1">
//                                     <i className="ri-arrow-left-right-line me-2 text-primary"></i>
//                                     Compare {flightLeg.dcPriceDetails.length}{" "}
//                                     Supplier Combinations
//                                   </div>
//                                   <div className="small text-muted d-none d-md-block">
//                                     Scroll horizontally to view more →
//                                   </div>
//                                 </div>

//                                 <div
//                                   className="d-flex flex-nowrap overflow-auto gap-3 pb-3 custom-horizontal-scrollbar"
//                                   style={{ cursor: "grab" }}
//                                 >
//                                   {flightLeg.dcPriceDetails
//                                     .sort((a, b) => a.totalPrice - b.totalPrice)
//                                     .map((fare, i) => {
//                                       const isCheapest = i === 0;
//                                       const isFareSelected =
//                                         selectedFares[
//                                           flightData[activeTab]?.journeyType
//                                         ]?.fare?.supplierPriceId ===
//                                         fare.supplierPriceId;

//                                       return (
//                                         <div
//                                           key={i}
//                                           onClick={() =>
//                                             handleSelectFare(
//                                               flightData[activeTab]
//                                                 ?.journeyType,
//                                               flightLeg,
//                                               fare.supplierPriceId,
//                                             )
//                                           }
//                                           className="flex-shrink-0 shadow-sm transition-all"
//                                           style={{
//                                             width: "240px", // Adjusted for longer labels
//                                             borderRadius: "16px",
//                                             background: isFareSelected
//                                               ? "#2563EB"
//                                               : "#FFFFFF",
//                                             color: isFareSelected
//                                               ? "#FFFFFF"
//                                               : "inherit",
//                                             border: isFareSelected
//                                               ? "2px solid #2563EB"
//                                               : "1px solid #E2E8F0",
//                                             cursor: "pointer",
//                                             padding: "12px",
//                                           }}
//                                         >
//                                           {/* Header: Supplier & Identifier */}
//                                           <div className="d-flex justify-content-between align-items-start mb-2">
//                                             <div className="lh-1">
//                                               <div
//                                                 className={`fw-bold small mb-1 ${isFareSelected ? "text-white" : "text-dark"}`}
//                                               >
//                                                 {fare.supplierName}
//                                               </div>
//                                               <span
//                                                 className={`badge px-2 py-1 ${isFareSelected ? "bg-white text-primary shadow-sm" : "bg-soft-primary text-primary"}`}
//                                                 style={{ fontSize: "8px" }}
//                                               >
//                                                 {fare.fareIdentifier}
//                                               </span>
//                                             </div>
//                                             {isCheapest && !isFareSelected && (
//                                               <i className="ri-medal-fill text-success fs-5"></i>
//                                             )}
//                                             {isFareSelected && (
//                                               <i className="ri-checkbox-circle-fill text-white fs-5 shadow-sm"></i>
//                                             )}
//                                           </div>

//                                           {/* Middle Section: FULL DATA GRID (2x2) */}
//                                           <div
//                                             className="border-top border-bottom py-2 my-2"
//                                             style={{
//                                               borderColor: isFareSelected
//                                                 ? "rgba(255,255,255,0.2)"
//                                                 : "#f1f1f1",
//                                             }}
//                                           >
//                                             {/* Row 1: Refundable & Meal */}
//                                             <div className="row g-0 mb-2">
//                                               <div
//                                                 className="col-6 border-end text-center"
//                                                 style={{
//                                                   borderColor: isFareSelected
//                                                     ? "rgba(255,255,255,0.2)"
//                                                     : "#f1f1f1",
//                                                 }}
//                                               >
//                                                 <i
//                                                   className={`ri-refresh-line ${isFareSelected ? "text-white" : fare.dcAdults?.refundable === "Refundable" ? "text-success" : "text-danger"}`}
//                                                 ></i>
//                                                 {/* FIX 1: Updated labels to REFUNDABLE / NON-REFUNDABLE */}
//                                                 <div
//                                                   style={{ fontSize: "8px" }}
//                                                   className="fw-bold px-1 text-uppercase"
//                                                 >
//                                                   {fare.dcAdults?.refundable ===
//                                                   "Refundable"
//                                                     ? "REFUNDABLE"
//                                                     : "NON-REFUNDABLE"}
//                                                 </div>
//                                               </div>
//                                               <div className="col-6 text-center px-1">
//                                                 <i
//                                                   className={`ri-restaurant-line ${isFareSelected ? "text-white" : fare.dcAdults?.mealType === "Free Meal" ? "text-warning" : "text-danger"}`}
//                                                 ></i>
//                                                 <div
//                                                   style={{ fontSize: "8px" }}
//                                                   className="fw-bold text-uppercase"
//                                                 >
//                                                   {fare.dcAdults?.mealType}
//                                                 </div>
//                                               </div>
//                                             </div>

//                                             {/* Row 2: Cabin & Check-in Baggage */}
//                                             <div
//                                               className="row g-0 border-top pt-2"
//                                               style={{
//                                                 borderColor: isFareSelected
//                                                   ? "rgba(255,255,255,0.1)"
//                                                   : "#f1f1f1",
//                                               }}
//                                             >
//                                               <div
//                                                 className="col-6 border-end text-center"
//                                                 style={{
//                                                   borderColor: isFareSelected
//                                                     ? "rgba(255,255,255,0.2)"
//                                                     : "#f1f1f1",
//                                                 }}
//                                               >
//                                                 <i
//                                                   className={`ri-handbag-line ${isFareSelected ? "text-white" : "text-muted"}`}
//                                                 ></i>
//                                                 <div
//                                                   style={{ fontSize: "8px" }}
//                                                   className="fw-bold px-1"
//                                                 >
//                                                   Cabin: {fare.cabinBaggage}
//                                                 </div>
//                                               </div>
//                                               <div className="col-6 text-center px-1">
//                                                 <i
//                                                   className={`ri-briefcase-4-line ${isFareSelected ? "text-white" : "text-muted"}`}
//                                                 ></i>
//                                                 <div
//                                                   style={{ fontSize: "8px" }}
//                                                   className="fw-bold"
//                                                 >
//                                                   Checkin: {fare.checkinBag}
//                                                 </div>
//                                               </div>
//                                             </div>
//                                           </div>

//                                           {/* Bottom: Pricing */}
//                                           <div className="text-center">
//                                             <div
//                                               className={`small fw-bold mb-0 ${isFareSelected ? "text-white-50" : "text-muted"}`}
//                                               style={{ fontSize: "10px" }}
//                                             >
//                                               TOTAL FARE
//                                             </div>
//                                             {/* FIX 2: Added text-white to ensure visibility on blue background */}
//                                             <div
//                                               className={`d-flex align-items-center justify-content-center gap-1 ${isFareSelected ? "text-white" : "text-dark"}`}
//                                             >
//                                               <span className="small opacity-75">
//                                                 {currency}
//                                               </span>
//                                               <h4
//                                                 className="fw-black mb-0"
//                                                 style={{ fontSize: "22px" }}
//                                               >
//                                                 {fare.totalPrice.toLocaleString()}
//                                               </h4>
//                                             </div>
//                                           </div>
//                                         </div>
//                                       );
//                                     })}
//                                 </div>
//                               </div>

//                               <style>{`
//       .custom-horizontal-scrollbar::-webkit-scrollbar { height: 6px; }
//       .custom-horizontal-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
//       .custom-horizontal-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
//       .custom-horizontal-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
//     `}</style>
//                             </div>
//                           )}
//                           {/* MODAL SECTION (Fixed: Placed inside map) */}
//                           {/* UPGRADED FLIGHT DETAILS MODAL (WITH ALL DATA) */}
//                           <div
//                             id={"flight" + flightLeg.supplierLegId}
//                             className="modal fade"
//                             role="dialog"
//                             aria-hidden="true"
//                           >
//                             <div className="modal-dialog modal-lg modal-dialog-centered">
//                               <div
//                                 className="modal-content border-0 shadow-lg"
//                                 style={{ borderRadius: "24px" }}
//                               >
//                                 {/* 1. Modal Header */}
//                                 <div className="modal-header border-bottom-0 p-4 pb-0">
//                                   <h5 className="modal-title fw-bold text-dark fs-4">
//                                     Flight Details
//                                   </h5>
//                                   <button
//                                     type="button"
//                                     className="btn-close shadow-none"
//                                     data-bs-dismiss="modal"
//                                   ></button>
//                                 </div>

//                                 <div className="modal-body p-4">
//                                   {/* 2. Journey Overview Header */}
//                                   <div className="bg-light p-3 rounded-4 d-flex justify-content-between align-items-center mb-4 border">
//                                     <div className="fw-bolder fs-5 text-dark">
//                                       {mainLeg?.startSegment?.city}
//                                       <i className="ri-arrow-right-line mx-3 text-primary"></i>
//                                       {mainLeg?.endSegment?.city}
//                                     </div>
//                                     <div className="text-muted small fw-bold text-uppercase ls-1">
//                                       <i className="ri-calendar-line me-1"></i>{" "}
//                                       {moment(
//                                         mainLeg?.startSegment
//                                           ?.departureDateTime,
//                                       ).format("DD MMM YYYY")}
//                                     </div>
//                                   </div>

//                                   {/* 3. Segments Loop */}
//                                   <div className="flight-segments">
//                                     {flightLeg.dcSegments.map((seg, sIdx) => (
//                                       <React.Fragment key={sIdx}>
//                                         <div className="row g-4 align-items-start py-4">
//                                           {/* Column A: Airline Info */}
//                                           <div className="col-lg-3 text-center text-lg-start border-end-lg">
//                                             <div className="d-flex align-items-center flex-column flex-lg-row gap-2">
//                                               <img
//                                                 src={
//                                                   "/assets/images/airlinelogos/" +
//                                                   seg?.tFAirlineData
//                                                     ?.airlineCode +
//                                                   ".png"
//                                                 }
//                                                 width="45"
//                                                 className="rounded-2 shadow-sm p-1 border bg-white"
//                                               />
//                                               <div>
//                                                 <div className="fw-bolder text-dark mb-0">
//                                                   {seg.tFAirlineData?.airline}
//                                                 </div>
//                                                 <div className="text-muted small fw-bold">
//                                                   {
//                                                     seg.tFAirlineData
//                                                       ?.equimentType
//                                                   }{" "}
//                                                   •{" "}
//                                                   {
//                                                     seg.tFAirlineData
//                                                       ?.flightNumber
//                                                   }
//                                                 </div>
//                                               </div>
//                                             </div>
//                                           </div>

//                                           {/* Column B: Departure */}
//                                           <div className="col-lg-3 text-center">
//                                             <div className="fw-black text-dark fs-3 mb-0">
//                                               {moment(
//                                                 seg.tFDepartureData
//                                                   .departureDateTime,
//                                               ).format("HH:mm")}
//                                             </div>
//                                             <div className="fw-bolder text-primary mb-1">
//                                               {seg.tFDepartureData.airportCode}
//                                             </div>
//                                             <div
//                                               className="small text-muted fw-medium px-2"
//                                               style={{ lineHeight: "1.2" }}
//                                             >
//                                               {seg.tFDepartureData.airportName},{" "}
//                                               {seg.tFDepartureData.city}
//                                             </div>
//                                             {seg.tFDepartureData.terminal && (
//                                               <span className="badge bg-light text-dark border mt-2">
//                                                 Terminal{" "}
//                                                 {seg.tFDepartureData.terminal}
//                                               </span>
//                                             )}
//                                           </div>

//                                           {/* Column C: Duration Visual */}
//                                           <div className="col-lg-3 text-center d-flex flex-column align-items-center justify-content-center">
//                                             <div className="text-muted small fw-bold mb-1">
//                                               {getTimeFromMins(
//                                                 seg?.tFAirlineData?.duration,
//                                               )}
//                                             </div>
//                                             <div className="d-flex align-items-center w-100 px-3 opacity-50">
//                                               <div
//                                                 className="border-bottom border-secondary flex-grow-1"
//                                                 style={{ height: "1px" }}
//                                               ></div>
//                                               <i className="ri-plane-fill mx-2 text-primary fs-5"></i>
//                                               <div
//                                                 className="border-bottom border-secondary flex-grow-1"
//                                                 style={{ height: "1px" }}
//                                               ></div>
//                                             </div>
//                                             <div className="small text-muted mt-1 fw-medium">
//                                               Duration
//                                             </div>
//                                           </div>

//                                           {/* Column D: Arrival */}
//                                           <div className="col-lg-3 text-center">
//                                             <div className="fw-black text-dark fs-3 mb-0">
//                                               {moment(
//                                                 seg.tFArrivalData
//                                                   .arrivalDateTime,
//                                               ).format("HH:mm")}
//                                             </div>
//                                             <div className="fw-bolder text-primary mb-1">
//                                               {seg.tFArrivalData.airportCode}
//                                             </div>
//                                             <div
//                                               className="small text-muted fw-medium px-2"
//                                               style={{ lineHeight: "1.2" }}
//                                             >
//                                               {seg.tFArrivalData.airportName},{" "}
//                                               {seg.tFArrivalData.city}
//                                             </div>
//                                             {seg.tFArrivalData.terminal && (
//                                               <span className="badge bg-light text-dark border mt-2">
//                                                 Terminal{" "}
//                                                 {seg.tFArrivalData.terminal}
//                                               </span>
//                                             )}
//                                           </div>
//                                         </div>

//                                         {/* 4. Layover / Connecting Time Logic (From your old code) */}
//                                         {seg?.tFAirlineData?.connectingTime !==
//                                           0 && (
//                                           <div className="my-2 px-4 py-2 bg-warning-subtle rounded-pill d-flex align-items-center justify-content-center gap-2 border border-warning-subtle">
//                                             <i className="ri-time-line text-warning fw-bold"></i>
//                                             <span className="small fw-bold text-dark">
//                                               Layover in{" "}
//                                               {seg.tFArrivalData.city}:{" "}
//                                               {getTimeFromMins(
//                                                 seg?.tFAirlineData
//                                                   ?.connectingTime,
//                                               )}
//                                             </span>
//                                           </div>
//                                         )}
//                                       </React.Fragment>
//                                     ))}
//                                   </div>
//                                 </div>

//                                 {/* 5. Trust Footer */}
//                                 <div className="modal-footer border-top-0 p-4 bg-light rounded-bottom-4 justify-content-center">
//                                   <p className="small text-muted mb-0">
//                                     <i className="ri-information-fill me-1"></i>{" "}
//                                     Check-in baggage & meals vary by supplier.
//                                     Please verify on the next step.
//                                   </p>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             )}
//             {/* end col */}
//           </div>
//           {/* end row */}
//         </div>
//         {/* container-fluid */}
//       </div>
//       {pageLoading === false ? (
//         Object.keys(selectedFares).length > 0 ? (
//           <div className="round-trip-fare fixed-bottom bg-dark shadow-md text-light">
//             <div className="container p-2">
//               <div className="row align-items-center">
//                 <div className="col-9">
//                   <div className="row">
//                     {Object.entries(selectedFares).map(([journeyType, sf]) => (
//                       <div
//                         key={journeyType}
//                         className={
//                           "border-right border-dark" +
//                             Object.keys(selectedFares).length >
//                           1
//                             ? "col-sm-6"
//                             : "col-sm-12"
//                         }
//                       >
//                         <div className="row align-items-center flex-row">
//                           <div className="col col-sm-4 col-md-3 text-center d-lg-flex company-info">
//                             <span className="align-middle d-none d-sm-block">
//                               <img
//                                 className="img-fluid me-2"
//                                 alt
//                                 width={"30px"}
//                                 height={"30px"}
//                                 src={`/assets/images/airlinelogos/${sf.flightLeg?.dcDisplayLegs[0]?.airlineData?.airlineCode}.png`}
//                               />
//                             </span>
//                             <span className="align-middle ml-lg-2">
//                               <span className="d-block text-1">
//                                 {
//                                   sf.flightLeg?.dcDisplayLegs[0]?.airlineData
//                                     ?.airline
//                                 }
//                               </span>
//                               <small className="text-white d-block">
//                                 {
//                                   sf.flightLeg?.dcDisplayLegs[0]?.airlineData
//                                     ?.airlineCode
//                                 }
//                                 -
//                                 {
//                                   sf.flightLeg?.dcDisplayLegs[0]?.airlineData
//                                     ?.flightNumber
//                                 }
//                               </small>
//                             </span>
//                           </div>
//                           <div className="col col-sm-4 col-md-3 text-center time-info">
//                             <span className="text-4">
//                               {moment(
//                                 sf.flightLeg?.dcDisplayLegs[0]?.startSegment
//                                   ?.departureDateTime,
//                               ).format("HH:mm")}
//                             </span>
//                             <small className="text-white d-none d-lg-block">
//                               {
//                                 sf.flightLeg?.dcDisplayLegs[0]?.startSegment
//                                   ?.city
//                               }
//                             </small>
//                           </div>
//                           <div className="col col-sm-4 col-md-3 text-center time-info">
//                             <span className="text-4">
//                               {moment(
//                                 sf.flightLeg?.dcDisplayLegs[0]?.endSegment
//                                   ?.arrivalDateTime,
//                               ).format("HH:mm")}
//                             </span>
//                             <small className="text-white d-none d-lg-block">
//                               {sf.flightLeg?.dcDisplayLegs[0]?.endSegment?.city}
//                             </small>
//                           </div>
//                           <div className="col-md-3 text-center d-none d-md-block time-info">
//                             <span className="text-1">
//                               {Math.floor(
//                                 sf.flightLeg?.dcDisplayLegs[0]?.totalDuration /
//                                   60,
//                               )}
//                               h{" "}
//                               {sf.flightLeg?.dcDisplayLegs[0]?.totalDuration %
//                                 60}
//                               m
//                             </span>
//                             <small className="text-white d-block">
//                               Non Stop
//                             </small>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="col-3">
//                   <div className="row align-items-center">
//                     <div className="col-12 col-md-6 text-light text-center text-6 price">
//                       <span className="text-1 text-white d-none d-lg-block">
//                         Total Fare:{" "}
//                       </span>
//                       {currency}{" "}
//                       {Object.values(selectedFares)
//                         .reduce(
//                           (sum, sf) => sum + (sf.fare?.totalPrice || 0),
//                           0,
//                         )
//                         .toFixed(2)}
//                     </div>
//                     <div className="col-12 col-md-6 text-center mt-2 mt-md-0 btn-book">
//                       <button
//                         onClick={handleSubmit}
//                         className="btn btn-sm btn-primary px-sm-2 px-lg-3"
//                       >
//                         <i className="fas fa-shopping-cart d-block d-lg-none" />
//                         <span className="d-none d-lg-block">Book Now</span>
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           ""
//         )
//       ) : (
//         ""
//       )}
//       <BookingConfirmationModal
//         show={showBookingModal}
//         onHide={() => setShowBookingModal(false)}
//         onContinue={handleContinueBooking}
//         onBookWithSupplier={handleBookWithSupplier}
//       />
//     </div>
//   );
// };

// export default Flights;

import React, { useState, useEffect } from "react";
import moment from "moment";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import FlightLoader from "../../Common/Layout/FlightLoader";
import BookingConfirmationModal from "./BookingConfirmationModal";
import ModifyFlightSearch1 from "../../template-library/FlightPanel/ModifyFlightSearch/ModifyFlightSearch1";
import styles from "./Flights.module.css"; // Import CSS Module
import { ShareEmail } from "../../Common/Helpers/ShareEmail";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import {
  RiPriceTag3Line,
  RiExternalLinkLine,
  RiInformationLine,
} from "react-icons/ri";

const Flights = () => {
  const { user, loading, currencies } = useAuth();
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [pageLoading, setPageLoading] = useState(false);
  const [currency, setCurrency] = useState(user?.currency || "INR");
  const [flightData, setFlightData] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [selectedFares, setSelectedFares] = useState({});
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedFlightForModal, setSelectedFlightForModal] = useState(null);
  const [selectedFareForBooking, setSelectedFareForBooking] = useState(null);
  const [showFareModal, setShowFareModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedFlightForDetail, setSelectedFlightForDetail] = useState(null);
  const [bookingSource, setBookingSource] = useState(null);
  const [supplierUrl, setSupplierUrl] = useState("");
  const [debug, setDebug] = useState({});
  const [showSelectionSummary, setShowSelectionSummary] = useState(false);
  const [selectedFlightsForSummary, setSelectedFlightsForSummary] = useState([]);
  const [passengerInfo, setPassengerInfo] = useState({
    adults: params.adults || 1,
    kids: params.kids || 0,
    infants: params.infants || 0,
    cabinClass: "ECONOMY"
  });

  // New states for Series Fares
  const [seriesFaresCount, setSeriesFaresCount] = useState(0);
  const [loadingSeriesFares, setLoadingSeriesFares] = useState(false);

  // Filter states
  const [filters, setFilters] = useState({
    stops: [],
    departureTime: "",
    priceRange: 50000,
    airlines: [],
  });

  // Determine journey type from searchQuery
  const journeyType = searchQuery?.journeyType || "ONEWAY";
  const isRoundTrip = journeyType === "RETURN";

  // Update passenger info when searchQuery changes
  useEffect(() => {
    if (searchQuery) {
      setPassengerInfo({
        adults: searchQuery.adults || params.adults || 1,
        kids: searchQuery.kids || params.kids || 0,
        infants: searchQuery.infants || params.infants || 0,
        cabinClass: searchQuery.cabinClass || "ECONOMY"
      });
    }
  }, [searchQuery, params]);

  // Get unique airlines from flight data
  const getAirlines = () => {
    const set = new Set();
    flightData.forEach((tab) => {
      if (tab?.dcFlightLegs && Array.isArray(tab.dcFlightLegs)) {
        tab.dcFlightLegs.forEach((flight) => {
          const airline = flight?.dcDisplayLegs?.[0]?.airlineData?.airline;
          if (airline) set.add(airline);
        });
      }
    });
    return Array.from(set);
  };

  // Handle filter changes
  const handleFilterChange = (type, value) => {
    setFilters((prev) => {
      if (type === "stops") {
        const updated = prev.stops.includes(value)
          ? prev.stops.filter((v) => v !== value)
          : [...prev.stops, value];
        return { ...prev, stops: updated };
      } else if (type === "airlines") {
        const updated = prev.airlines.includes(value)
          ? prev.airlines.filter((v) => v !== value)
          : [...prev.airlines, value];
        return { ...prev, airlines: updated };
      } else if (type === "departureTime") {
        return { ...prev, departureTime: value };
      } else if (type === "priceRange") {
        return { ...prev, priceRange: parseInt(value) };
      }
      return prev;
    });
  };

  // Clear all filters
  const handleClearFilters = () => {
    setFilters({
      stops: [],
      departureTime: "",
      priceRange: 50000,
      airlines: [],
    });
  };

  // Apply filters to flights
  const applyFilters = (flights) => {
    if (!flights || !Array.isArray(flights)) return [];

    return flights.filter((flight) => {
      const displayLeg = flight?.dcDisplayLegs?.[0];
      if (!displayLeg) return false;

      const airline = displayLeg?.airlineData?.airline;
      const stops = displayLeg?.stops;
      const price = flight.totalPrice || 0;

      let departureHour = 0;
      if (displayLeg?.startSegment?.departureDateTime) {
        try {
          departureHour = new Date(
            displayLeg.startSegment.departureDateTime,
          ).getHours();
        } catch (e) {
          console.warn(
            "Invalid date format:",
            displayLeg.startSegment.departureDateTime,
          );
        }
      }

      const stopMatch =
        filters.stops.length === 0 ||
        (stops !== undefined &&
          stops !== null &&
          filters.stops.includes(stops));

      const airlineMatch =
        filters.airlines.length === 0 ||
        (airline && filters.airlines.includes(airline));

      const priceMatch = price <= filters.priceRange;

      let timeMatch = true;
      if (filters.departureTime) {
        if (filters.departureTime === "morning") {
          timeMatch = departureHour >= 5 && departureHour < 12;
        } else if (filters.departureTime === "afternoon") {
          timeMatch = departureHour >= 12 && departureHour < 17;
        } else if (filters.departureTime === "evening") {
          timeMatch = departureHour >= 17 && departureHour < 21;
        } else if (filters.departureTime === "night") {
          timeMatch = departureHour >= 21 || departureHour < 5;
        }
      }

      return stopMatch && airlineMatch && priceMatch && timeMatch;
    });
  };

  // Format duration
  const getTimeFromMins = (mins) => {
    if (!mins && mins !== 0) return "0h 0m";
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m}m`;
  };

  // Format fare type with supplier
  const formatFareType = (fare) => {
    const fareType = fare?.fareIdentifier || "PUBLISHED";
    const supplier = fare?.supplierName || "SUPPLIER";
    return `${fareType}/${supplier}`.toUpperCase();
  };

  // Get fare type color class
  const getFareTypeColor = (fare) => {
    const supplier = fare?.supplierName?.toLowerCase() || "";
    if (supplier.includes("tripjack")) return styles.fareTypeTripjack;
    if (supplier.includes("upfront")) return styles.fareTypeUpfront;
    return styles.fareTypeDefault;
  };

  // Share via WhatsApp
  const shareViaWhatsApp = (flightLeg) => {
    const displayLeg = flightLeg.dcDisplayLegs[0];
    const passengerDetails = [
      passengerInfo.adults > 0 &&
        `${passengerInfo.adults} Adult${passengerInfo.adults > 1 ? "s" : ""}`,
      passengerInfo.kids > 0 && `${passengerInfo.kids} Kid${passengerInfo.kids > 1 ? "s" : ""}`,
      passengerInfo.infants > 0 &&
        `${passengerInfo.infants} Infant${passengerInfo.infants > 1 ? "s" : ""}`,
    ]
      .filter(Boolean)
      .join(" | ");

    const minPrice = Math.min(
      ...flightLeg.dcPriceDetails.map((fare) => fare.totalPrice || Infinity),
    );

    const message = `Hello Traveler, please find your flight details:

Journey: ${flightData[activeTab]?.locationFrom} - ${flightData[activeTab]?.locationTo}
Passengers: ${passengerDetails}
Cabin Class: ${flightLeg.dcPriceDetails[0]?.dcAdults?.cabinClass}

FLIGHT DETAILS:
----------------------------------------------------------------
ONWARD: 🛫 ${displayLeg.airlineData.airline} (${displayLeg.airlineData.flightNumber}) : 
${displayLeg.startSegment.airportCode} (${displayLeg.startSegment.city}) - ${displayLeg.endSegment.airportCode} (${displayLeg.endSegment.city})
Departure: ${moment(displayLeg.startSegment.departureDateTime).format("ddd, DD MMM YY HH:mm")}
Arrival: ${moment(displayLeg.endSegment.arrivalDateTime).format("ddd, DD MMM YY HH:mm")}
Duration: ${getTimeFromMins(displayLeg.totalDuration)} / ${
      displayLeg.stops === 0
        ? "Non-stop"
        : `${displayLeg.stops} stop${displayLeg.stops > 1 ? "s" : ""}`
    }

TOTAL PRICE: ${currency} ${minPrice.toLocaleString("en-IN")}
----------------------------------------------------------------
Thank you for choosing ${user?.brandName || "us"}

In case of any support:
☎️ Contact : ${user?.phoneNumber || "N/A"}
✉ Email     : ${user?.email || "N/A"}`;

    window.open(
      `https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`,
      "_blank",
    );
  };

  // Share via Email
  const shareViaEmail = (flightLeg) => {
    const displayLeg = flightLeg.dcDisplayLegs[0];
    const minPrice = Math.min(
      ...flightLeg.dcPriceDetails.map((fare) => fare.totalPrice || Infinity),
    );

    const subject = `Your Flight Details: ${flightData[activeTab]?.locationFrom} to ${flightData[activeTab]?.locationTo}`;
    const body = `Hello,

Please find details with regards to your flight(s) query for:
${flightData[activeTab]?.locationFrom} - ${flightData[activeTab]?.locationTo}
${passengerInfo.adults} Adult${passengerInfo.adults > 1 ? "s" : ""}
${flightLeg.dcPriceDetails[0]?.fareIdentifier}

Below mentioned prices are the total price(s) inclusive of taxes:
----------------------------------------------------------------
ONWARD: 🛫 ${displayLeg.airlineData.airline} (${displayLeg.airlineData.flightNumber}) : 
${displayLeg.startSegment.airportCode} (${displayLeg.startSegment.city}) - ${displayLeg.endSegment.airportCode} (${displayLeg.endSegment.city})
Departure: ${moment(displayLeg.startSegment.departureDateTime).format("ddd, DD MMM YY HH:mm")}
Arrival: ${moment(displayLeg.endSegment.arrivalDateTime).format("ddd, DD MMM YY HH:mm")}
Duration: ${getTimeFromMins(displayLeg.totalDuration)} / ${
      displayLeg.stops === 0
        ? "Non-stop"
        : `${displayLeg.stops} stop${displayLeg.stops > 1 ? "s" : ""}`
    }

TOTAL PRICE: ${currency} ${minPrice.toLocaleString("en-IN")}
----------------------------------------------------------------
Thank you for choosing ${user?.brandName || "us"}

In case of any support:
Contact: ${user?.phoneNumber || "N/A"}
Email: ${user?.email || "N/A"}

Best regards,
${user?.name || "Travel Team"}`;

    ShareEmail({
      subject,
      body,
      preferGmail: false,
    });
  };

  // Handle fare selection
  const handleSelectFare = (
    journeyType,
    flightLeg,
    fare,
    isOutbound = true,
  ) => {
    setSelectedFares((prev) => {
      if (!isRoundTrip) {
        return {
          [journeyType]: {
            flightLeg,
            fare,
          },
        };
      }

      const newSelection = { ...prev };
      const routeKey = isOutbound ? "outbound" : "return";

      newSelection[routeKey] = {
        flightLeg,
        fare,
        journeyType: journeyType,
        route: isOutbound ? "outbound" : "return",
        locationFrom: flightLeg?.dcDisplayLegs?.[0]?.startSegment?.airportCode,
        locationTo: flightLeg?.dcDisplayLegs?.[0]?.endSegment?.airportCode,
      };

      return newSelection;
    });
  };

  // Check if flight is selected
  const isFlightSelected = (journeyType, supplierLegId, isOutbound = true) => {
    if (!isRoundTrip) {
      return (
        selectedFares[journeyType]?.flightLeg?.supplierLegId === supplierLegId
      );
    } else {
      const routeKey = isOutbound ? "outbound" : "return";
      return (
        selectedFares[routeKey]?.flightLeg?.supplierLegId === supplierLegId
      );
    }
  };

  // Get minimum price for a flight
  const getMinPrice = (flightLeg) => {
    if (!flightLeg?.dcPriceDetails?.length) return 0;
    return Math.min(
      ...flightLeg.dcPriceDetails.map((fare) => fare.totalPrice || Infinity),
    );
  };

  // Open fare modal
  const openFareModal = (flight) => {
    setSelectedFlightForModal(flight);
    setShowFareModal(true);
  };

  // Open detail modal
  const openDetailModal = (flight) => {
    setSelectedFlightForDetail(flight);
    setShowDetailModal(true);
  };

  // Handle book with supplier
  const handleBookWithSupplier = (url) => {
    setShowBookingModal(false);
    if (url) {
      window.open(url, "_blank");
    } else {
      window.open("https://www.tripjack.com/home/login", "_blank");
    }
  };

  // Handle select flight - shows selection summary popup
  const handleSelectFlight = (journeyType, flightLeg, isOutbound = true) => {
    const cheapestFare = [...flightLeg.dcPriceDetails].sort((a, b) => a.totalPrice - b.totalPrice)[0];
    
    const supplierPrimaryDomain = cheapestFare?.primaryDomain || 
                                  flightLeg?.primaryDomain || 
                                  "https://www.tripjack.com/home/login";
    
    setSupplierUrl(supplierPrimaryDomain);

    handleSelectFare(journeyType, flightLeg, cheapestFare, isOutbound);

    if (isRoundTrip) {
      const routeKey = isOutbound ? "outbound" : "return";
      const otherRouteKey = isOutbound ? "return" : "outbound";

      if (selectedFares[otherRouteKey]) {
        // Both flights selected, show summary popup
        const selectedFlights = [
          {
            ...selectedFares[otherRouteKey],
            route: otherRouteKey
          },
          {
            flightLeg,
            fare: cheapestFare,
            route: routeKey,
            locationFrom: flightLeg?.dcDisplayLegs?.[0]?.startSegment?.airportCode,
            locationTo: flightLeg?.dcDisplayLegs?.[0]?.endSegment?.airportCode,
          }
        ];
        setSelectedFlightsForSummary(selectedFlights);
        setShowSelectionSummary(true);
      } else {
        alert(`Please select your ${isOutbound ? 'return' : 'outbound'} flight as well`);
      }
    } else {
      // One-way: show summary popup with single flight
      setSelectedFlightsForSummary([{
        flightLeg,
        fare: cheapestFare,
        locationFrom: flightLeg?.dcDisplayLegs?.[0]?.startSegment?.airportCode,
        locationTo: flightLeg?.dcDisplayLegs?.[0]?.endSegment?.airportCode,
      }]);
      setShowSelectionSummary(true);
    }
  };

  // Handle view fares and select (from the fare modal)
  const handleViewFaresAndSelect = (journeyType, flightLeg, fare) => {
    const supplierPrimaryDomain = fare?.primaryDomain || 
                                  flightLeg?.primaryDomain || 
                                  "https://www.tripjack.com/home/login";
    
    setSupplierUrl(supplierPrimaryDomain);

    const isOutbound = activeTab === 0;
    handleSelectFare(journeyType, flightLeg, fare, isOutbound);

    if (isRoundTrip) {
      const routeKey = isOutbound ? "outbound" : "return";
      const otherRouteKey = isOutbound ? "return" : "outbound";

      if (selectedFares[otherRouteKey]) {
        // Both flights selected, show summary popup
        const selectedFlights = [
          {
            ...selectedFares[otherRouteKey],
            route: otherRouteKey
          },
          {
            flightLeg,
            fare,
            route: routeKey,
            locationFrom: flightLeg?.dcDisplayLegs?.[0]?.startSegment?.airportCode,
            locationTo: flightLeg?.dcDisplayLegs?.[0]?.endSegment?.airportCode,
          }
        ];
        setSelectedFlightsForSummary(selectedFlights);
        setShowSelectionSummary(true);
        setShowFareModal(false);
      } else {
        alert(
          `Please select your ${isOutbound ? "return" : "outbound"} flight as well`,
        );
        setShowFareModal(false);
      }
    } else {
      // One-way: show summary popup with single flight
      setSelectedFlightsForSummary([{
        flightLeg,
        fare,
        locationFrom: flightLeg?.dcDisplayLegs?.[0]?.startSegment?.airportCode,
        locationTo: flightLeg?.dcDisplayLegs?.[0]?.endSegment?.airportCode,
      }]);
      setShowSelectionSummary(true);
      setShowFareModal(false);
    }
  };

  // Handle proceed to booking from summary - shows booking confirmation modal
  const handleProceedToBooking = () => {
    setShowSelectionSummary(false);
    
    if (isRoundTrip) {
      if (selectedFares.outbound && selectedFares.return) {
        setBookingSource('both');
        setShowBookingModal(true);
      }
    } else {
      const journeyTypeKey = Object.keys(selectedFares)[0];
      setSelectedFlightForModal(selectedFares[journeyTypeKey]?.flightLeg);
      setSelectedFareForBooking(selectedFares[journeyTypeKey]?.fare);
      setBookingSource('oneway');
      setShowBookingModal(true);
    }
  };

  const handleModifySearch = (newSearchQuery) => {
    setSearchQuery(newSearchQuery);
    setPageLoading(true);
    GetFlights(newSearchQuery);
    fetchSeriesFaresCount(newSearchQuery);
    // Clear selected fares when search is modified
    setSelectedFares({});
    setSelectedFlightsForSummary([]);
  };

  // Function to fetch series fares count
  const fetchSeriesFaresCount = async (searchQuery) => {
    try {
      setLoadingSeriesFares(true);

      const firstTrip = searchQuery.flightTravelerPoints?.[0];
      if (!firstTrip) {
        setSeriesFaresCount(0);
        return;
      }

      const from = firstTrip.from || "";
      const to = firstTrip.to || "";
      const date = firstTrip.departureDate || "";
      const pax =
        (searchQuery.adults || 0) +
        (searchQuery.kids || 0) +
        (searchQuery.infants || 0);

      if (!from || !to || !date) {
        setSeriesFaresCount(0);
        return;
      }

      const response = await apiService.getAll(
        `${config.SERIESFARESEARCH}?from=${from}&to=${to}&date=${date}&pax=${pax}`,
      );

      if (response && response.count !== undefined) {
        setSeriesFaresCount(response.count);
      } else {
        setSeriesFaresCount(0);
      }
    } catch (error) {
      console.error("Error fetching series fares count:", error);
      setSeriesFaresCount(0);
    } finally {
      setLoadingSeriesFares(false);
    }
  };

  // Handle viewing series fares
  const handleViewSeriesFares = () => {
    if (!state?.searchQuery) return;

    const searchQuery = state.searchQuery;
    const firstTrip = searchQuery.flightTravelerPoints?.[0];

    if (!firstTrip) return;

    const seriesSearchData = {
      from: firstTrip.from || "",
      to: firstTrip.to || "",
      date: firstTrip.departureDate || "",
      pax:
        (searchQuery.adults || 0) +
        (searchQuery.kids || 0) +
        (searchQuery.infants || 0),
      cabinClass: searchQuery.cabinClass || "ECONOMY",
      journeyType: searchQuery.journeyType || "ONEWAY",
      isDomestic: searchQuery.isDomestic || "DOMESTIC",
    };

    navigate("/seriesfare/agent-search", {
      state: {
        searchQuery: seriesSearchData,
        passengerCount: seriesSearchData.pax,
        shouldAutoSearch: true,
        fromAirportCode: firstTrip.from,
        toAirportCode: firstTrip.to,
        travelDate: firstTrip.departureDate,
      },
    });
  };

  const GetFlights = async (searchQuery) => {
    try {
      console.log("Search Query:", searchQuery);
      const result = await apiService.post(config.SEARCHFLIGHTS, searchQuery);
      console.log("API Result:", result);

      if (result && result.length > 0) {
        const sortedData = result.map((destination) => {
          if (
            destination?.dcFlightLegs &&
            Array.isArray(destination.dcFlightLegs)
          ) {
            const sortedLegs = [...destination.dcFlightLegs].sort(
              (a, b) => (a.totalPrice || 0) - (b.totalPrice || 0),
            );

            return {
              ...destination,
              dcFlightLegs: sortedLegs,
            };
          }
          return destination;
        });

        console.log("Sorted Data:", sortedData);
        setFlightData(sortedData);
        setSelectedFares({});
        setActiveTab(0);
      } else {
        console.log("No flights found in response");
        setFlightData([]);
        alert("No flights found");
      }
    } catch (error) {
      console.error("Error fetching flights:", error);
      alert("Error fetching flights: " + (error.message || "Unknown error"));
    }
    setPageLoading(false);
  };

  // Handle currency change
  const handleCurrencyChange = () => {
    setCurrency(currency === "USD" ? "INR" : "USD");
  };

  // Load initial data
  useEffect(() => {
    console.log("State:", state);
    console.log("Params:", params);

    if (state === null || params === null || !state?.searchQuery) {
      navigate("/flight/search");
    } else {
      setSearchQuery(state.searchQuery);
      setPageLoading(true);
      GetFlights(state.searchQuery);
      fetchSeriesFaresCount(state.searchQuery);
    }

    if (loading) return;
    if (!user) {
      navigate("/");
    }
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!user) return null;

  console.log("Flight Data:", flightData);
  console.log("Is Round Trip:", isRoundTrip);

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection="flights" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className={styles.mainContainer}>
              {/* Modify Search Component */}
              <ModifyFlightSearch1
                onSearch={handleModifySearch}
                initialSearchQuery={searchQuery}
              />

              {/* Flight Layout */}
              {pageLoading ? (
                <div className="row">
                  <div className="col-12">
                    <div className="text-center">
                      <div className="branded-loader-wrapper">
                        <FlightLoader />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.flightLayout}>
                  {/* Filter Sidebar */}
                  <div className={styles.filterSidebar}>
                    <div className={styles.filterHeader}>
                      <h5>
                        <i className="fas fa-sliders-h me-2"></i>Filters
                      </h5>
                      <a
                        href="#"
                        id="sf1-clearFilters"
                        onClick={(e) => {
                          e.preventDefault();
                          handleClearFilters();
                        }}
                      >
                        Clear All
                      </a>
                    </div>

                    {/* Series Fares Filter */}
                    <div className={styles.seriesFaresFilter}>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <RiPriceTag3Line
                            className="me-2 text-info"
                            style={{ fontSize: "1.2rem" }}
                          />
                          <p
                            className="text-muted text-uppercase fw-medium mb-0"
                            style={{ fontSize: "13px" }}
                          >
                            Series Fares
                          </p>
                        </div>
                        <div className="text-end">
                          {loadingSeriesFares ? (
                            <span
                              className="spinner-border spinner-border-sm text-info"
                              role="status"
                            ></span>
                          ) : (
                            <span className="badge bg-info rounded-pill">
                              {seriesFaresCount}
                            </span>
                          )}
                        </div>
                      </div>

                      <div
                        className="text-muted small mb-2"
                        style={{ fontSize: "11px" }}
                      >
                        Guaranteed seat packages at fixed prices
                      </div>

                      <button
                        type="button"
                        className="btn btn-info btn-sm w-100"
                        onClick={handleViewSeriesFares}
                        disabled={seriesFaresCount === 0 || loadingSeriesFares}
                        style={{
                          backgroundColor: "#0dcaf0",
                          borderColor: "#0dcaf0",
                          color: "#010d0fff",
                          fontSize: "12px",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                      >
                        {loadingSeriesFares ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                            ></span>
                            Checking...
                          </>
                        ) : (
                          <>
                            <RiExternalLinkLine className="me-1" />
                            {seriesFaresCount > 0
                              ? `View ${seriesFaresCount} Series Fare${seriesFaresCount > 1 ? "s" : ""}`
                              : "No Series Fares"}
                          </>
                        )}
                      </button>

                      {seriesFaresCount > 0 && (
                        <div
                          className="mt-2 text-info small"
                          style={{ fontSize: "11px" }}
                        >
                          <RiInformationLine className="me-1" />
                          Click to view fixed-price guaranteed seats
                        </div>
                      )}
                    </div>

                    {/* Stops Filter */}
                    <div className={styles.filterGroup}>
                      <p>Stops</p>
                      {[0, 1, 2].map((stop) => (
                        <div className={styles.filterCheckbox} key={stop}>
                          <input
                            type="checkbox"
                            id={`sf1-stop${stop}`}
                            value={stop}
                            checked={filters.stops.includes(stop)}
                            onChange={() => handleFilterChange("stops", stop)}
                          />
                          <label htmlFor={`sf1-stop${stop}`}>
                            {stop === 0
                              ? "Non-stop"
                              : `${stop} Stop${stop > 1 ? "s" : ""}`}
                          </label>
                        </div>
                      ))}
                    </div>

                    {/* Departure Time */}
                    <div className={styles.filterGroup}>
                      <p>Departure Time</p>
                      {[
                        { value: "morning", label: "Morning (5am - 12pm)" },
                        { value: "afternoon", label: "Afternoon (12pm - 5pm)" },
                        { value: "evening", label: "Evening (5pm - 9pm)" },
                        { value: "night", label: "Night (9pm - 5am)" },
                      ].map((time) => (
                        <div className={styles.filterCheckbox} key={time.value}>
                          <input
                            type="radio"
                            name="sf1-departureTime"
                            id={`sf1-${time.value}`}
                            value={time.value}
                            checked={filters.departureTime === time.value}
                            onChange={() =>
                              handleFilterChange("departureTime", time.value)
                            }
                          />
                          <label htmlFor={`sf1-${time.value}`}>
                            {time.label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {/* Price Range */}
                    <div className={styles.filterGroup}>
                      <p>Price Range (Up to ₹{filters.priceRange})</p>
                      <input
                        type="range"
                        className={styles.rangeSlider}
                        id="sf1-priceRange"
                        min="0"
                        max="100000"
                        step="1000"
                        value={filters.priceRange}
                        onChange={(e) =>
                          handleFilterChange(
                            "priceRange",
                            parseInt(e.target.value),
                          )
                        }
                      />
                      <div className={styles.rangeValues}>
                        <span>₹0</span>
                        <span>
                          Up to ₹
                          <span id="sf1-maxPrice">{filters.priceRange}</span>
                        </span>
                      </div>
                    </div>

                    {/* Airlines */}
                    <div className={styles.filterGroup}>
                      <p>Airlines</p>
                      <div id="sf1-airlineFilters">
                        {getAirlines().map((airline) => (
                          <div className={styles.filterCheckbox} key={airline}>
                            <input
                              type="checkbox"
                              className="sf1-airline-filter"
                              value={airline}
                              id={`sf1-airline-${airline}`}
                              checked={filters.airlines.includes(airline)}
                              onChange={() =>
                                handleFilterChange("airlines", airline)
                              }
                            />
                            <label htmlFor={`sf1-airline-${airline}`}>
                              {airline}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Results Area */}
                  <div className={styles.resultsArea}>
                    {/* Flight Count with Route Tabs */}
                    <div className={styles.flightCountCard}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          flexWrap: "wrap",
                        }}
                      >
                        <span className={styles.flightCountBadge}>
                          <i className="fas fa-plane"></i>{" "}
                          <span id="sf1-flightCountNumber">
                            {flightData && flightData.length > 0
                              ? flightData[activeTab]?.dcFlightLegs?.length || 0
                              : 0}
                          </span>{" "}
                          flights available
                        </span>
                        {flightData && flightData.length > 0 && (
                          <div className={styles.routeTabsVertical}>
                            {flightData.map((item, index) => (
                              <button
                                key={index}
                                className={`${styles.routeTabBtn} ${activeTab === index ? styles.active : ""}`}
                                id={`sf1-tab${index}`}
                                onClick={() => setActiveTab(index)}
                              >
                                {item.locationFrom || "From"} →{" "}
                                {item.locationTo || "To"}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      <span className={styles.sortInfo}>
                        <i className="fas fa-sort-amount-down"></i> sorted by
                        best
                      </span>
                    </div>

                    {/* Flight Results Container */}
                    <div
                      id="sf1-flightResultsContainer"
                      className={styles.flightList}
                    >
                      {flightData && flightData.length > 0 ? (
                        flightData.map((destination, destIndex) => {
                          const isOutbound = destIndex === 0;
                          const filteredFlights = applyFilters(
                            destination?.dcFlightLegs || [],
                          );

                          return (
                            <div
                              key={destIndex}
                              className={`${styles.routeSection} ${activeTab === destIndex ? styles.active : ""}`}
                              id={`sf1-section${destIndex}`}
                            >
                              {filteredFlights.length > 0 ? (
                                <div className={styles.flightList}>
                                  {filteredFlights.map((flightLeg, idx) => {
                                    const displayLeg =
                                      flightLeg?.dcDisplayLegs?.[0];
                                    if (!displayLeg) return null;

                                    const airlineData = displayLeg?.airlineData;
                                    const minPrice = getMinPrice(flightLeg);
                                    const isSelected = isRoundTrip
                                      ? isFlightSelected(
                                          destination?.journeyType,
                                          flightLeg?.supplierLegId,
                                          isOutbound,
                                        )
                                      : isFlightSelected(
                                          destination?.journeyType,
                                          flightLeg?.supplierLegId,
                                        );
                                    const fareIdentifier =
                                      flightLeg?.dcPriceDetails?.[0]
                                        ?.fareIdentifier || "PUBLISHED";
                                    const supplierName =
                                      flightLeg?.dcPriceDetails?.[0]
                                        ?.supplierName || "Supplier";

                                    return (
                                      <div className={`${styles.flightCard} ${isSelected ? styles.selected : ""}`} key={idx}>
                                        {/* Airline Section with Flight Details Button */}
                                        <div className={styles.airlineSection}>
                                          <div className={styles.airlineLogo}>
                                            <img
                                              src={`/assets/images/airlinelogos/${airlineData?.airlineCode || "default"}.png`}
                                              alt={airlineData?.airline}
                                              style={{
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "contain",
                                              }}
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = "none";
                                                e.target.parentNode.innerHTML =
                                                  '<i className="fas fa-building"></i>';
                                              }}
                                            />
                                          </div>
                                          <div className={styles.airlineInfo}>
                                            <h3>{airlineData?.flightNumber || "N/A"}</h3>
                                            <p>{airlineData?.airline || "Unknown Airline"}</p>
                                            {/* Flight Details Button moved here */}
                                            <button
                                              className={styles.flightDetailsBtnSmall}
                                              onClick={() => openDetailModal(flightLeg)}
                                            >
                                              <i className="fas fa-info-circle"></i> Details
                                            </button>
                                          </div>
                                        </div>

                                        {/* Route Section */}
                                        <div
                                          className={styles.routeSectionCompact}
                                        >
                                          <div className={styles.fromPoint}>
                                            <div className={styles.code}>
                                              {displayLeg?.startSegment
                                                ?.airportCode || "---"}
                                            </div>
                                            <div className={styles.time}>
                                              {displayLeg?.startSegment
                                                ?.departureDateTime
                                                ? moment(
                                                    displayLeg.startSegment
                                                      .departureDateTime,
                                                  ).format("HH:mm")
                                                : "--:--"}
                                            </div>
                                            <div className={styles.date}>
                                              {displayLeg?.startSegment
                                                ?.departureDateTime
                                                ? moment(
                                                    displayLeg.startSegment
                                                      .departureDateTime,
                                                  ).format("DD MMM YY")
                                                : "---"}
                                            </div>
                                          </div>

                                          <div
                                            className={styles.durationSection}
                                          >
                                            <div className={styles.duration}>
                                              {getTimeFromMins(
                                                displayLeg?.totalDuration,
                                              )}
                                            </div>
                                            <div className={styles.flightLine}>
                                              <span className={styles.dots}>
                                                .............
                                              </span>
                                            </div>
                                            <span className={styles.stopBadge}>
                                              {displayLeg?.stops === 0
                                                ? "Non Stop"
                                                : `${displayLeg?.stops || 0} Stop${displayLeg?.stops > 1 ? "s" : ""}`}
                                            </span>
                                          </div>

                                          <div className={styles.toPoint}>
                                            <div className={styles.code}>
                                              {displayLeg?.endSegment
                                                ?.airportCode || "---"}
                                            </div>
                                            <div className={styles.time}>
                                              {displayLeg?.endSegment
                                                ?.arrivalDateTime
                                                ? moment(
                                                    displayLeg.endSegment
                                                      .arrivalDateTime,
                                                  ).format("HH:mm")
                                                : "--:--"}
                                            </div>
                                            <div className={styles.date}>
                                              {displayLeg?.endSegment
                                                ?.arrivalDateTime
                                                ? moment(
                                                    displayLeg.endSegment
                                                      .arrivalDateTime,
                                                  ).format("DD MMM YY")
                                                : "---"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Price & Action - Vertical Stack */}
                                        <div className={styles.priceActionVertical}>
                                          {/* Baggage Icons in Horizontal Row */}
                                          <div className={styles.baggageRow}>
                                            <div className={styles.baggageItem}>
                                              <span className={styles.baggageIcon}>🧳</span>
                                              <span className={styles.baggageValue}>{flightLeg?.dcPriceDetails?.[0]?.cabinBaggage || "7 Kg"}</span>
                                            </div>

                                            <div className={styles.baggageItem}>
                                              <span className={styles.baggageIcon}>🎒</span>
                                              <span className={styles.baggageValue}>{flightLeg?.dcPriceDetails?.[0]?.checkinBag || "20 Kg"}</span>
                                            </div>

                                            <div className={styles.baggageItem}>
                                              <span className={styles.baggageIcon}>💺</span>
                                              <span className={styles.baggageValue}>{flightLeg?.noOfSeats || "5"} seats</span>
                                            </div>
                                          </div>
                                          
                                          {/* Compare Fares Button - Full Display */}
                                          <button
                                            className={styles.viewFaresBtnFull}
                                            onClick={() => openFareModal(flightLeg)}
                                          >
                                            <i className="fas fa-tags"></i> Compare Fares
                                          </button>
                                        </div>

                                        {/* Baggage Section */}
                                        <div className={styles.baggageSection}>
                                          <div className={styles.fareRow}>
                                            <span className={`${styles.fareType} ${getFareTypeColor(flightLeg?.dcPriceDetails?.[0])}`}>
                                              {formatFareType(flightLeg?.dcPriceDetails?.[0])}
                                            </span>
                                          </div>
                                          <div className={styles.price}>
                                            <span className={styles.currency}>
                                              {currency}
                                            </span>
                                            <span className={styles.amount}>
                                              {Math.round(
                                                minPrice,
                                              ).toLocaleString()}
                                            </span>
                                          </div>
                                         
                                          <div className={styles.actionContainer}>
                                            {/* Share Icons */}
                                            <div className={styles.shareIcons}>
                                              <Link
                                                onClick={() => shareViaWhatsApp(flightLeg)}
                                                className="text-success"
                                                title="Share via WhatsApp"
                                                style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                              >
                                                <FaWhatsapp />
                                              </Link>

                                              <Link
                                                onClick={() => shareViaEmail(flightLeg)}
                                                className="text-primary"
                                                title="Share via Email"
                                                style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                              >
                                                <FaEnvelope />
                                              </Link>
                                            </div>

                                            <button
                                              className={styles.selectBtn}
                                              onClick={() =>
                                                handleSelectFlight(
                                                  destination?.journeyType || "ONEWAY",
                                                  flightLeg,
                                                  isOutbound
                                                )
                                              }
                                            >
                                              SELECT
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <div className={styles.noFlightsMessage}>
                                  <p>
                                    No flights match your filters. Try adjusting
                                    your search criteria.
                                  </p>
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className={styles.noFlightsMessage}>
                          <p>
                            No flights available. Please try a different search.
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Selected Flights Summary for Round Trip */}
                    {isRoundTrip && Object.keys(selectedFares).length > 0 && (
                      <div className={styles.selectedFlightsSummary}>
                        <h5>Selected Flights</h5>
                        {selectedFares.outbound && (
                          <div className={styles.selectedFlightItem}>
                            <span>
                              Outbound:{" "}
                              {selectedFares.outbound.locationFrom || "---"} →{" "}
                              {selectedFares.outbound.locationTo || "---"}
                            </span>
                            <span className={styles.selectedPrice}>
                              {currency}{" "}
                              {Math.round(
                                selectedFares.outbound.fare?.totalPrice || 0,
                              ).toLocaleString()}
                            </span>
                          </div>
                        )}
                        {selectedFares.return && (
                          <div className={styles.selectedFlightItem}>
                            <span>
                              Return:{" "}
                              {selectedFares.return.locationFrom || "---"} →{" "}
                              {selectedFares.return.locationTo || "---"}
                            </span>
                            <span className={styles.selectedPrice}>
                              {currency}{" "}
                              {Math.round(
                                selectedFares.return.fare?.totalPrice || 0,
                              ).toLocaleString()}
                            </span>
                          </div>
                        )}
                        {selectedFares.outbound && selectedFares.return && (
                          <div className={styles.selectedTotal}>
                            <strong>
                              Total: {currency}{" "}
                              {Math.round(
                                (selectedFares.outbound.fare?.totalPrice || 0) +
                                  (selectedFares.return.fare?.totalPrice || 0),
                              ).toLocaleString()}
                            </strong>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* View Fares Modal */}
      {showFareModal && selectedFlightForModal && (
        <div
          className={styles.modalOverlay}
          onClick={() => setShowFareModal(false)}
        >
          <div
            className={`${styles.modalContent} ${styles.modalXl}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h5 className={styles.modalTitle}>
                Select Fare Type -{" "}
                {selectedFlightForModal?.dcDisplayLegs?.[0]?.airlineData
                  ?.flightNumber || "N/A"}{" "}
                ·{" "}
                {selectedFlightForModal?.dcDisplayLegs?.[0]?.airlineData
                  ?.airline || "Unknown"}
              </h5>
              <button
                className={styles.modalClose}
                onClick={() => setShowFareModal(false)}
              >
                &times;
              </button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.fareOptionsList}>
                {selectedFlightForModal?.dcPriceDetails?.map((fare, index) => {
                  const currentJourneyType =
                    flightData[activeTab]?.journeyType || "ONEWAY";
                  const isOutbound = activeTab === 0;
                  const routeKey = isRoundTrip
                    ? isOutbound
                      ? "outbound"
                      : "return"
                    : currentJourneyType;
                  const isSelected =
                    selectedFares[routeKey]?.fare?.supplierPriceId ===
                    fare?.supplierPriceId;

                  return (
                    <div
                      key={index}
                      className={`${styles.fareOption} ${isSelected ? styles.selected : ""}`}
                      onClick={() =>
                        handleViewFaresAndSelect(
                          currentJourneyType,
                          selectedFlightForModal,
                          fare,
                        )
                      }
                    >
                      <div className={styles.fareRadio}>
                        <input
                          type="radio"
                          name="sf1-fareOption"
                          checked={isSelected}
                          readOnly
                        />
                      </div>
                      <div className={styles.fareDetails}>
                        <span className={styles.farePrice}>{currency} {Math.round(fare?.totalPrice || 0).toLocaleString()}</span>
                        <span className={`${styles.fareName} ${getFareTypeColor(fare)}`}>
                          {fare?.fareIdentifier || "PUBLISHED"}
                        </span>
                        <span className={styles.fareSupplier} style={{fontSize: '1rem'}}>
                          <i className="fas fa-building"></i> {fare?.supplierName || "Supplier"}
                        </span>
                        <span className={styles.fareRefund}>
                          <i
                            className={`fas fa-${fare?.dcAdults?.refundable === "Refundable" ? "check-circle" : "times-circle"}`}
                          ></i>
                          {fare?.dcAdults?.refundable === "Refundable"
                            ? " REFUNDABLE"
                            : " NON-REFUNDABLE"}
                        </span>
                        <span className={styles.fareMeal}>
                          <i className="fas fa-utensils"></i>
                          {fare?.dcAdults?.mealType === "Free Meal"
                            ? " FREE MEAL"
                            : " PAID MEAL"}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                className={`${styles.modalBtn} ${styles.modalBtnDanger}`}
                onClick={() => setShowFareModal(false)}
              >
                Cancel
              </button>
              <button
                className={`${styles.modalBtn} ${styles.modalBtnPrimary}`}
                onClick={() => setShowFareModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Flight Details Modal - For single flight details */}
      {showDetailModal && selectedFlightForDetail && (
        <div
          className={styles.modalOverlay}
          onClick={() => setShowDetailModal(false)}
        >
          <div
            className={`${styles.modalContent} ${styles.modalLg}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h5 className={styles.modalTitle}>
                Flight Details -{" "}
                {selectedFlightForDetail?.dcDisplayLegs?.[0]?.airlineData
                  ?.flightNumber || "N/A"}{" "}
                ·{" "}
                {selectedFlightForDetail?.dcDisplayLegs?.[0]?.airlineData
                  ?.airline || "Unknown"}
              </h5>
              <button
                className={styles.modalClose}
                onClick={() => setShowDetailModal(false)}
              >
                &times;
              </button>
            </div>
            <div className={styles.modalBody}>
              {selectedFlightForDetail?.dcSegments?.map((segment, idx) => {
                const displayLeg = selectedFlightForDetail?.dcDisplayLegs?.[0];
                return (
                  <div className={styles.flightSegment} key={idx}>
                    <div className={styles.segmentHeader}>
                      <div className={styles.segmentAirline}>
                        <img
                          src={`/assets/images/airlinelogos/${segment?.tFAirlineData?.airlineCode || "default"}.png`}
                          alt={segment?.tFAirlineData?.airlineCode}
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.parentNode.innerHTML =
                              '<i className="fas fa-building"></i>';
                          }}
                        />
                        <div>
                          <h6 className="mb-0 fw-bold">
                            {segment?.tFAirlineData?.airline || "Unknown"}
                          </h6>
                          <small className="text-muted">
                            {segment?.tFAirlineData?.flightNumber || "N/A"} ·{" "}
                            {segment?.tFAirlineData?.equipmentType || "A380"}
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className={styles.segmentTimeline}>
                      <div className="text-center">
                        <div className="fw-bold fs-5">
                          {segment?.tFDepartureData?.departureDateTime
                            ? moment(
                                segment.tFDepartureData.departureDateTime,
                              ).format("HH:mm")
                            : "--:--"}
                        </div>
                        <span
                          className={`${styles.badge} ${styles.badgeLight}`}
                        >
                          {segment?.tFDepartureData?.airportCode || "---"}
                        </span>
                        <div className="small mt-1">
                          {segment?.tFDepartureData?.city || "Unknown"}
                        </div>
                        {segment?.tFDepartureData?.terminal && (
                          <small className="text-muted">
                            Terminal {segment.tFDepartureData.terminal}
                          </small>
                        )}
                      </div>

                      <div className="text-center">
                        <div className="small fw-bold mb-1">
                          {getTimeFromMins(segment?.tFAirlineData?.duration)}
                        </div>
                        <i className="fas fa-plane text-primary"></i>
                        <div className="small text-muted mt-1">
                          {displayLeg?.stops === 0
                            ? "Non Stop"
                            : `${displayLeg?.stops || 0} Stop${displayLeg?.stops > 1 ? "s" : ""}`}
                        </div>
                      </div>

                      <div className="text-center">
                        <div className="fw-bold fs-5">
                          {segment?.tFArrivalData?.arrivalDateTime
                            ? moment(
                                segment.tFArrivalData.arrivalDateTime,
                              ).format("HH:mm")
                            : "--:--"}
                        </div>
                        <span
                          className={`${styles.badge} ${styles.badgeLight}`}
                        >
                          {segment?.tFArrivalData?.airportCode || "---"}
                        </span>
                        <div className="small mt-1">
                          {segment?.tFArrivalData?.city || "Unknown"}
                        </div>
                        {segment?.tFArrivalData?.terminal && (
                          <small className="text-muted">
                            Terminal {segment.tFArrivalData.terminal}
                          </small>
                        )}
                      </div>
                    </div>

                    {idx < selectedFlightForDetail.dcSegments.length - 1 && (
                      <div className={styles.layoverInfo}>
                        <i className="fas fa-clock"></i>
                        Layover in{" "}
                        {selectedFlightForDetail.dcSegments[idx]?.tFArrivalData
                          ?.city || "Unknown"}
                        :{" "}
                        {getTimeFromMins(
                          selectedFlightForDetail.dcSegments[idx + 1]
                            ?.tFAirlineData?.connectingTime || 90,
                        )}
                      </div>
                    )}
                  </div>
                );
              })}

              <div className={styles.flightDetailFooter}>
                <div className="row">
                  <div className="col-4">
                    <i className="fas fa-suitcase"></i>
                    <div>
                      <strong>
                        {selectedFlightForDetail?.dcPriceDetails?.[0]
                          ?.cabinBaggage || "7 Kg"}
                      </strong>
                    </div>
                    <small>Cabin</small>
                  </div>
                  <div className="col-4">
                    <i className="fas fa-briefcase"></i>
                    <div>
                      <strong>
                        {selectedFlightForDetail?.dcPriceDetails?.[0]
                          ?.checkinBag || "20 Kg"}
                      </strong>
                    </div>
                    <small>Check-in</small>
                  </div>
                  <div className="col-4">
                    <i className="fas fa-chair"></i>
                    <div>
                      <strong>
                        {selectedFlightForDetail?.noOfSeats || "5"} seats
                      </strong>
                    </div>
                    <small>Available</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Selection Summary Modal */}
     {/* Selection Summary Modal */}
{showSelectionSummary && selectedFlightsForSummary.length > 0 && (
  <div className={styles.modalOverlay} onClick={() => setShowSelectionSummary(false)}>
    <div className={`${styles.modalContent} ${styles.modalLg}`} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalHeader}>
        <h5 className={styles.modalTitle}>
          {isRoundTrip ? "Selected Round Trip Flights" : "Selected Flight"}
        </h5>
        <button className={styles.modalClose} onClick={() => setShowSelectionSummary(false)}>&times;</button>
      </div>
      <div className={styles.modalBody}>
        {/* Travelers & Cabin Information Combined */}
        <div className={styles.summarySection}>
          <h6><i className="fas fa-users me-2"></i>Travelers & Cabin</h6>
          <div className={styles.travelerCabinInfo}>
            <div className={styles.travelerInfo}>
              <span className={styles.travelerBadge}>{passengerInfo.adults} Adult{passengerInfo.adults > 1 ? 's' : ''}</span>
              {passengerInfo.kids > 0 && <span className={styles.travelerBadge}>{passengerInfo.kids} Kid{passengerInfo.kids > 1 ? 's' : ''}</span>}
              {passengerInfo.infants > 0 && <span className={styles.travelerBadge}>{passengerInfo.infants} Infant{passengerInfo.infants > 1 ? 's' : ''}</span>}
            </div>
            <div className={styles.cabinBadge}>
              <i className="fas fa-chair me-1"></i>
              {passengerInfo.cabinClass || "ECONOMY"}
            </div>
          </div>
        </div>

        {/* Flight Details */}
        {selectedFlightsForSummary.map((flight, index) => {
          const displayLeg = flight.flightLeg?.dcDisplayLegs?.[0];
          if (!displayLeg) return null;
          
          return (
            <div key={index} className={styles.summaryFlightCard}>
              {isRoundTrip && (
                <div className={styles.summaryRouteHeader}>
                  {flight.route === "outbound" ? "Outbound Flight" : "Return Flight"}
                </div>
              )}
              
              <div className={styles.summaryAirline}>
                <img 
                  src={`/assets/images/airlinelogos/${displayLeg?.airlineData?.airlineCode || 'default'}.png`}
                  alt={displayLeg?.airlineData?.airline}
                  style={{ width: '30px', height: '30px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<i className="fas fa-building"></i>';
                  }}
                />
                <div>
                  <strong>{displayLeg?.airlineData?.airline}</strong>
                  <span className={styles.summaryFlightNumber}> ({displayLeg?.airlineData?.flightNumber})</span>
                </div>
              </div>

              <div className={styles.summaryRoute}>
                <div className={styles.summaryPoint}>
                  <div className={styles.summaryTime}>
                    {moment(displayLeg?.startSegment?.departureDateTime).format("HH:mm")}
                  </div>
                  <div className={styles.summaryCode}>{displayLeg?.startSegment?.airportCode}</div>
                  <div className={styles.summaryCity}>{displayLeg?.startSegment?.city}</div>
                  <div className={styles.summaryDate}>
                    {moment(displayLeg?.startSegment?.departureDateTime).format("DD MMM YY")}
                  </div>
                </div>

                <div className={styles.summaryDuration}>
                  <div>{getTimeFromMins(displayLeg?.totalDuration)}</div>
                  <i className="fas fa-plane"></i>
                  <div className={styles.summaryStops}>
                    {displayLeg?.stops === 0 ? "Non-stop" : `${displayLeg?.stops} stop${displayLeg?.stops > 1 ? 's' : ''}`}
                  </div>
                </div>

                <div className={styles.summaryPoint}>
                  <div className={styles.summaryTime}>
                    {moment(displayLeg?.endSegment?.arrivalDateTime).format("HH:mm")}
                  </div>
                  <div className={styles.summaryCode}>{displayLeg?.endSegment?.airportCode}</div>
                  <div className={styles.summaryCity}>{displayLeg?.endSegment?.city}</div>
                  <div className={styles.summaryDate}>
                    {moment(displayLeg?.endSegment?.arrivalDateTime).format("DD MMM YY")}
                  </div>
                </div>
              </div>

              <div className={styles.summaryFareInfo}>
                <span className={`${styles.summaryFareType} ${getFareTypeColor(flight.fare)}`}>
                  {formatFareType(flight.fare)}
                </span>
                <span className={styles.summaryPrice}>
                  {currency} {Math.round(flight.fare?.totalPrice || 0).toLocaleString()}
                </span>
              </div>

              <div className={styles.summaryBaggage}>
                <span><i className="fas fa-suitcase"></i> Cabin: {flight.fare?.cabinBaggage || "7 Kg"}</span>
                <span><i className="fas fa-briefcase"></i> Check-in: {flight.fare?.checkinBag || "20 Kg"}</span>
              </div>
            </div>
          );
        })}

        {isRoundTrip && selectedFlightsForSummary.length === 2 && (
          <div className={styles.summaryTotal}>
            <strong>Total Price:</strong>
            <span className={styles.totalAmount}>
              {currency} {Math.round(
                selectedFlightsForSummary.reduce((sum, flight) => sum + (flight.fare?.totalPrice || 0), 0)
              ).toLocaleString()}
            </span>
          </div>
        )}
      </div>
      <div className={styles.modalFooter}>
        <button 
          className={`${styles.modalBtn} ${styles.modalBtnDanger}`} 
          onClick={() => setShowSelectionSummary(false)}
        >
          Cancel
        </button>
        <button 
          className={`${styles.modalBtn} ${styles.modalBtnPrimary}`} 
          onClick={handleProceedToBooking}
        >
          Book Now
        </button>
      </div>
    </div>
  </div>
)}

      {/* Booking Confirmation Modal */}
      <BookingConfirmationModal
        show={showBookingModal}
        onHide={() => setShowBookingModal(false)}
        onBookWithSupplier={handleBookWithSupplier}
        supplierUrl={supplierUrl}
      />
    </div>
  );
};

export default Flights;
